import { ConfigEntity } from '../models/Config';
import { fetchUrl } from './fetchUrl';

export async function fetchPartnerConfig() {
    return fetchUrl<ConfigEntity>({
        endpoint: '/v2/config',
        method: 'GET',
    });
}
